export interface AvailableBilling {
  subscriberBillingId: number;
  editionId: number;
  imageUrl?: string;
  delivered?: boolean;
}
